import { useMemo, useState } from 'react';
import Confirmation from 'components/Confirmation';
import ModalConfirmation from 'components/Confirmation/ModalConfirmation';
import { AppContextProvider } from 'contexts/AppContext';
import NotificationAlert from 'react-notification-alert';
import { useRef } from 'react';

const App = ({ children }) => {
  const [confirmation, setConfirmation] = useState({
    isShow: false,
    type: 'sweetAlert',
    onCancel: () => {
      setConfirmation((localConfirmation) => {
        return {
          ...localConfirmation,
          isShow: false,
          confirmTitle: ''
        };
      });
    }
  });

  const notificationAlertRef = useRef(null);

  const contextValue = useMemo(
    () => ({
      setConfirmation,
      notificationAlertRef
    }),
    []
  );

  const { type, ...restConfirmation } = confirmation;

  return (
    <AppContextProvider value={contextValue}>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      {type === 'sweetAlert' && <Confirmation {...restConfirmation} />}
      {type === 'modal' && <ModalConfirmation {...restConfirmation} />}
      {children}
    </AppContextProvider>
  );
};

export default App;
